<template>
  <v-container>
    <v-item-group mandatory>
      <v-container>
        <v-row>
          <Group v-for="group in groups" :group="group" :key="group.name"/>
        </v-row>
      </v-container>
    </v-item-group>
  </v-container>
</template>

<script>
  import Group from './Group.vue'

  export default {
    name: 'Groups',

    components: {
      Group
    },

    data: () => ({
      groups: [
        {
          name: 'All Items Group',
          image: 'all.jpg'
        },
        {
          name: 'Food',
          image: 'wazza.jpg'
        },
        {
          name: 'Milky',
          image: 'milk.jpg'
        },
        {
          name: 'All Items Group',
          image: 'all.jpg'
        },
        {
          name: 'Food',
          image: 'wazza.jpg'
        },
        {
          name: 'Milk',
          image: 'milk.jpg'
        }
      ]
    })
  }
</script>

<style>
</style>